import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    totalAreaContainer: {
      padding: '16px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      border: '1px solid #E0E0E0',
      boxShadow: 'none',
      '& .MuiTypography-gutterBottom': {
        marginBottom: '0px',
      },
    },
  }),
)
